export function quoteDollars(value: string, maximumCents = 100_000_000): number | null {
  if (!/^\d+(?:\.\d{1,2})?$/.test(value.trim())) return null;
  const [whole, fraction = ''] = value.trim().split('.');
  const cents = BigInt(whole) * 100n + BigInt(fraction.padEnd(2, '0'));
  return cents > 0n && cents <= BigInt(Number.MAX_SAFE_INTEGER) && cents <= BigInt(maximumCents)
    ? Number(cents)
    : null;
}
export function adminReturnPath(value: string | null): string {
  if (value === 'admin') return '/admin';
  return value &&
    /^\/admin\/quotes(?:\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})?$/.test(
      value
    )
    ? value
    : '/';
}
